module.exports = __webpack_public_path__ + "files/777e0307a52931675acea27e53abbd03.svg";